import { useEffect, useMemo, useState } from "react";

// material-ui
import { Box, Modal, Stack } from "@mui/material";

// project-imports
import MainCard from "components/MainCard";
import SimpleBar from "components/third-party/SimpleBar";
import CircularWithPath from "components/@extended/progress/CircularWithPath";

// types

import { bestPlace } from "model/ads";

import FormBestPlaceAdd from "./FormBestPlaceAdd";
import { useAppDispatch } from "hooks";

import { getAllCategories } from "store/actions/main/categories";
import { getAllCompanies } from "store/actions/main/companies";
import { getAllVacanciesOrder } from "store/actions/main/order/vacancyOrder";

interface Props {
  open: boolean;
  modalToggler: (state: boolean) => void;
  customer?: bestPlace | null;
  id: number;
  fetchData: any;
}

// ==============================|| CUSTOMER ADD / EDIT ||============================== //

const BestPlaceModal = ({
  fetchData,
  open,
  modalToggler,
  customer,
  id,
}: Props) => {
  const closeModal = () => modalToggler(false);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(true);

  const [userName, setUserName] = useState();
  const [catName, setCatName] = useState();
  const [Packages, setPackages] = useState();
  const fetchCompData = () => {
    setLoading(true);
    dispatch(getAllCompanies({ pageNumber: 1 }))
      .then((action) => {
        const { data } = action.payload;
        setLoading(false);
        // Extract user names
        setUserName(data); // Set user names as options for autocomplete
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching users:", error);
      });
  };
  const fetchDataCat = () => {
    setLoading(true);
    dispatch(getAllCategories({ pageNumber: 1 }))
      .then((action) => {
        const { data } = action.payload;

        // Extract user names
        setCatName(data);
        setLoading(false); // Set user names as options for autocomplete
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching users:", error);
      });
  };

  const fetchDataPackages = () => {
    setLoading(true);
    dispatch(getAllVacanciesOrder({ pageNumber: 1 }))
      .then((action) => {
        const { data } = action.payload;

        // Extract user names
        setPackages(data);
        setLoading(false); // Set user names as options for autocomplete
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching users:", error);
      });
  };
  useEffect(() => {
    // Fetch permissions data here
    fetchDataCat();
    fetchCompData();
    fetchDataPackages();
  }, [open, dispatch, id]);
  const customerForm = useMemo(
    () =>
      !loading && (
        <FormBestPlaceAdd
          id={id}
          loading={loading}
          Packages={Packages}
          catName={catName}
          userName={userName}
          setLoading={setLoading}
          fetchData={fetchData}
          customer={customer || null}
          closeModal={closeModal}
        />
      ),
    // eslint-disable-next-line
    [customer, loading],
  );

  return (
    <>
      {open && (
        <Modal
          open={open}
          onClose={closeModal}
          aria-labelledby="modal-customer-add-label"
          aria-describedby="modal-customer-add-description"
          sx={{
            "& .MuiPaper-root:focus": {
              outline: "none",
            },
          }}
        >
          <MainCard
            sx={{
              width: `calc(100% - 48px)`,
              minWidth: 340,
              maxWidth: 600,
              height: "auto",
              maxHeight: "calc(100vh - 48px)",
            }}
            modal
            content={false}
          >
            <SimpleBar
              sx={{
                maxHeight: `calc(100vh - 48px)`,
                "& .simplebar-content": {
                  display: "flex",
                  flexDirection: "column",
                },
              }}
            >
              {loading ? (
                <Box sx={{ p: 5 }}>
                  <Stack direction="row" justifyContent="center">
                    <CircularWithPath />
                  </Stack>
                </Box>
              ) : (
                customerForm
              )}
            </SimpleBar>
          </MainCard>
        </Modal>
      )}
    </>
  );
};

export default BestPlaceModal;
